import React, { useEffect, useState } from "react";
import AssessmentDataService from "../../services/Assessment";
import BookingDataService from "../../services/Booking";
import UserDataService from "../../services/User";
import { MonthlyBarChart } from "../../components/Chart/MonthlyBarChart";
export const Records = () => {
  const token = localStorage.getItem("logged_in_user_token");

  const [viewMode, setViewMode] = useState("last30Days");

  const [assessmentMonthlyData, setAssessmentMonthlyData] = useState<any>([]);

  const [appBookingMonthlyData, setAppBookingMonthlyData] = useState<any>([]);

  const [nonAppbookingMonthlyData, setNonAppBookingMonthlyData] = useState<any>(
    []
  );

  const [userMonthlyData, setUserMonthlyData] = useState<any>([]);

  const toggleViewMode = () => {
    setViewMode(viewMode === "last30Days" ? "currentmonth" : "last30Days");
  };
  const getDateFormat = (dateString: string) => {
    let date = new Date(dateString);
    let day = date.getDate();
    let monthIndex = date.getMonth();
    let year = date.getFullYear();
    let monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    let monthName = monthNames[monthIndex];
    let newDateString = day + "-" + monthName + "-" + year;
    return newDateString;
  };

  const calculateSumAfterRemovingLastN = (arr: any[], n: number) => {
    const modifiedArray = n > 0 ? arr.slice(0, -n) : arr;


    const totalSum = modifiedArray.reduce((sum, obj) => sum + obj.count, 0);

    // const average = (totalSum / modifiedArray.length).toFixed(2);

    return totalSum;
  };

  const fetchBookingMonthlyData = () => {
    BookingDataService.getBookingMonthlyData(viewMode)
      .then((res: any) => {
        const appBookings = res.data.appBookings.map((item: any) => {
          return {
            date: getDateFormat(item.date),
            count: item.count,
            App: 0,
          };
        });
        const nonAppBookings = res.data.nonAppBookings.map((item: any) => {
          return {
            date: getDateFormat(item.date),
            count: item.count,
            App: 0,
          };
        });
        setAppBookingMonthlyData(appBookings);
        setNonAppBookingMonthlyData(nonAppBookings);
      })
      .catch((e: any) => {
        console.log(e);
      });
  };

  const fetchUserMonthlyData = () => {
    UserDataService.getUserMonthlyData(viewMode)
      .then((res: any) => {
        const data = res.data.map((item: any) => {
          return {
            date: getDateFormat(item.date),
            count: item.count,
            App: 0,
          };
        });
        setUserMonthlyData(data);
      })
      .catch((e: any) => {
        console.log(e);
      });
  };

  const fetchAssessmentMonthlyData = () => {
    AssessmentDataService.getIntakeFormMonthlyData(token,viewMode)
      .then((res: any) => {
        const data = res.data.map((item: any) => {
          return {
            date: getDateFormat(item.date),
            count: item.count,
            App: item.appLeadCount,
          };
        });
        setAssessmentMonthlyData(data);
      })
      .catch((e: any) => {
        console.log(e);
      });
  };
  useEffect(() => {
    fetchBookingMonthlyData();
    fetchUserMonthlyData();
    fetchAssessmentMonthlyData();
  }, [viewMode]);
  return (
    <div className="main-wrapper">
      <div className="page_title py-2">Reachout - Reports</div>
      <div className="p-4">
        <div className="notification-header d-flex justify-content-between align-items-center mb-5">
          <button
            type="button"
            className="btn action-btn custom-btn notification-action-btn notification-btn"
            onClick={toggleViewMode}
          >
            {viewMode === "last30Days" ? "Current Month" : "Last 30 Days"}
          </button>
          <div className="notifications-title">
            {viewMode === "last30Days"
              ? "Last 30 Days Report"
              : "Current Month Report"}
          </div>
        </div>

        <div className="row justify-content-center">
          <div className=" text-center  col-sm-12">
            {assessmentMonthlyData && (
              <div className="chart-container">
                {" "}
                <MonthlyBarChart
                  data={assessmentMonthlyData}
                  isEHC={true}
                />{" "}
              </div>
            )}
          </div>
          <div className="mt-records">{`Daily Free consultation Scheduled (Total EHC : ${calculateSumAfterRemovingLastN(
            assessmentMonthlyData,
            7
          )})`}</div>
        </div>
        
        {/* moved to dolphin crm */}

        {/* <div className="row justify-content-center">
          <div className=" text-center  col-sm-12">
            {appBookingMonthlyData && (
              <div className="chart-container">
                {" "}
                <MonthlyBarChart data={appBookingMonthlyData} />{" "}
              </div>
            )}
          </div>
          <div className="mt-records">
            {`Daily App Bookings (Total App Bookings : ${calculateSumAfterRemovingLastN(
              appBookingMonthlyData,
              0
            )})`}{" "}
          </div>
        </div> */}
        {/* <div className="row justify-content-center">
          <div className=" text-center  col-sm-12">
            {nonAppbookingMonthlyData && (
              <div className="chart-container">
                {" "}
                <MonthlyBarChart data={nonAppbookingMonthlyData} />{" "}
              </div>
            )}
          </div>
          <div className="mt-records">{`Daily Provisional Bookings (Total Non App Bookings : ${calculateSumAfterRemovingLastN(
            nonAppbookingMonthlyData,
            0
          )})`}</div>
        </div> */}
        {/* <div className="row justify-content-center">
          <div className=" text-center  col-sm-12">
            {userMonthlyData && (
              <div className="chart-container">
                {" "}
                <MonthlyBarChart data={userMonthlyData} />{" "}
              </div>
            )}
          </div>
          <div className="mt-records">{`Daily User Registrations (Total Users : ${calculateSumAfterRemovingLastN(
            userMonthlyData,
            0
          )})`}</div>
        </div> */}
      </div>
    </div>
  );
};
